import { config } from "@/lib/config";
import type { components } from "@shared/types/api";

type VerifyMagicLinkResponse = components["schemas"]["VerifyMagicLinkResponse"];

export async function fetchValidateMagicLinkToken(token: string): Promise<VerifyMagicLinkResponse> {
    const baseUrl = config.apiUrl;
    const response = await fetch(`${baseUrl}/api/v1/auth/verify-magic-link`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
            errorData.error || `HTTP error! status: ${response.status}`,
        );
    }

    return response.json() as Promise<VerifyMagicLinkResponse>;
}
